import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Heart, Mic } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useIsMobile } from '@/hooks/use-mobile';
import { useLanguage } from '@/i18n/LanguageContext';

export function StickyMobileActionBar() {
  const isMobile = useIsMobile();
  const { t } = useLanguage();

  if (!isMobile) return null;

  return (
    <motion.div
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.5, type: 'spring', stiffness: 100 }}
      className="fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-lg border-t border-border shadow-lg"
    >
      <div className="flex items-center gap-3 p-3 max-w-lg mx-auto">
        <Link to="/signup" className="flex-1">
          <Button 
            size="lg" 
            className="w-full gap-2 bg-primary hover:bg-primary/90 text-primary-foreground font-semibold"
          >
            <Heart className="h-4 w-4" fill="currentColor" />
            {t.mobile.startWriting}
          </Button>
        </Link>
        <Link to="/signup">
          <Button 
            size="lg" 
            variant="outline"
            className="gap-2 border-primary/30 text-primary hover:bg-primary/10"
          >
            <Mic className="h-4 w-4" />
            {t.mobile.speak}
          </Button>
        </Link>
      </div>
      
      {/* Safe area padding for devices with home indicator */}
      <div className="h-safe-area-inset-bottom bg-background" />
    </motion.div>
  );
}
